import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getCategories } from "./request-orders.service";
import OrderHeader from "shared/component/orderHeader/orderHeader";
import "./requestOrders.scss";

const RequestOrders = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCategories()
      .then((data) => setCategories(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="myBooking">
      <div className="container">
        <OrderHeader title={t("request-orders.mainTitle")} handleSortDate={() => {}} />
        <p className="page-subtitle">{t("request-orders.categoriesDesc")}</p>

        {loading ? (
          <div className="loading-spinner">
            <div className="spinner-border text-primary" role="status" />
          </div>
        ) : (
          <div className="categories-grid">
            {categories.map((cat) => (
              <div
                key={cat.id}
                className="category-card"
                onClick={() => navigate(`/request-orders/${cat.id}`, { state: { categoryName: cat.name } })}
              >
                <div className="category-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z" />
                  </svg>
                </div>
                <h3 className="category-name">{cat.name}</h3>
              </div>
            ))}
            {categories.length === 0 && (
              <p className="no-data">{t("request-orders.noCategories")}</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestOrders;
